const pinChat = {
    title: 'Подсказка',
    description:
        'Вы можете закрепить чат в <b>отдельное окно</b>. Его можно разместить в <b>любом месте</b> страницы, перетащив за верхний край. Это <b>удобно</b>, если нужно отвечать собеседнику находясь в другом месте системы.',
    buttonText: 'Всё понятно!',
    mode: 'support',
} as const;

export default pinChat;
